import React, { ReactNode } from "react";
import { usePermissions } from "src/context/MeContext";
import type { Scope } from "src/rbac/scopes";

interface ScopeGateProps {
  scope: Scope;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Conditionally renders children based on scope permission.
 *
 * Usage:
 *   <ScopeGate scope="write:alert_responders">
 *     <Button onClick={handleEdit}>Edit</Button>
 *   </ScopeGate>
 *
 *   <ScopeGate
 *     scope="write:integrations"
 *     fallback={<Badge variant="secondary">Read Only</Badge>}
 *   >
 *     <Button onClick={handleEdit}>Edit</Button>
 *   </ScopeGate>
 */
export function ScopeGate({ scope, children, fallback = null }: ScopeGateProps) {
  const { hasScope } = usePermissions();
  return hasScope(scope) ? <>{children}</> : <>{fallback}</>;
}
